import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import cn from "classnames";

import { ChevronDownFill } from "@icons";
import { useElemRef } from "@utils/useElemRef";
import { tagular } from "@cohesion/tagular";

import styles from "./readMore.module.css";

export function ReadMore({
  content = "",
  wysiwyg = true,
  centered = false,
  ...props
}) {
  const [isVisible, setIsVisible] = useState(false);
  const [isMax, setIsMax] = useState(true);
  const [clientHeight, setRef] = useElemRef(node => node?.clientHeight || 0);

  function toggleVisible(e) {
    const parentElem = e.target.parentElement;
    // scrolls readmore into view when collapsing
    // the readmore content
    if (isVisible) {
      parentElem.scrollIntoView(true);
    }
    setIsVisible(!isVisible);
    tagular("click", {
      actionOutcome: isVisible ? "COLLAPSE" : "EXPAND",
      outboundUrl: "NULL",
      webElement: {
        location: "CONTENTBLOCK",
        elementType: "BUTTON",
        position: "OVERVIEW",
        text: isVisible ? "READLESS" : "READMORE",
      },
    });
  }
  useEffect(() => {
    setIsMax(clientHeight >= 384);
  }, [clientHeight]);

  return (
    <section className="read-more" {...props}>
      <div
        className={`${styles.content} relative overflow-hidden${
          !isVisible && isMax ? " max-h-96 is-max" : ""
        } ${wysiwyg ? " wysiwyg" : ""}`}
        /**
         * TODO: Refactor sanitizeHTML to handle refs.
         */
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML={{ __html: content }}
        ref={setRef}
      />
      {isMax && (
        <button
          className={cn(
            "text-blue font-semibold mt-2",
            centered && "block mx-auto"
          )}
          type="button"
          onClick={e => toggleVisible(e)}
        >
          Read {isVisible ? "less" : "more"}
          <ChevronDownFill
            className={`inline-block ml-2 text-xs${
              isVisible ? " transform rotate-180" : ""
            }`}
          />
        </button>
      )}
    </section>
  );
}

ReadMore.propTypes = {
  content: PropTypes.string,
  wysiwyg: PropTypes.bool,
  centered: PropTypes.bool,
};
